export default __webpack_public_path__ + "static/media/filmsinfo_logo.329aad30.png";